import styled from "vue-styled-components";
import { themeProps } from "./ThemeProps";
import ReadStyleGuide from "./ReadStyleGuide";

export const sTableData = styled("td", themeProps)`
  font-family: ${props =>
    props.fontFamily || ReadStyleGuide.font.family.didact};
`;
